import { CandlestickChart, Users, Coins, Brain, FlaskConical, Home, Landmark, PanelLeftClose, PanelLeftOpen } from "lucide-react";
import { cn } from "@/lib/utils";

const GROUPS = [
  { label: "Core", items: [{ id: "hub", label: "Hub", sub: "Briefing · P&L", Icon: Home }] },
  {
    label: "Esecuzione",
    items: [
      { id: "hyperliquid", label: "Hyperliquid", sub: "Perp + copy", Icon: Coins },
      { id: "polymarket", label: "Polymarket", sub: "Oracle + copy", Icon: Users },
      { id: "ctrader", label: "cTrader", sub: "Gold · Forex", Icon: CandlestickChart },
      { id: "invest", label: "Investimenti", sub: "ETF · Long-term", Icon: Landmark },
    ],
  },
  {
    label: "Intelligence",
    items: [
      { id: "cervello", label: "Cervello", sub: "Control center IA", Icon: Brain },
      { id: "lab", label: "LAB", sub: "Ricerca · Factory", Icon: FlaskConical },
    ],
  },
];

export const AppSidebar = ({ section, onSelect, counts = {}, collapsed, onToggle }) => (
  <aside
    data-testid="app-sidebar"
    className={cn(
      "hidden lg:flex fixed left-0 top-14 bottom-0 z-30 flex-col border-r border-border bg-[hsl(var(--card))] transition-[width] duration-200",
      collapsed ? "w-16" : "w-64"
    )}
  >
    <nav className="flex-1 overflow-y-auto thin-scroll py-6 space-y-7">
      <a href="/research" data-testid="sidebar-research-link" title="Ricerca per meccanismi" className={cn("flex items-center gap-3 mx-4 p-3 rounded-md border border-emerald-500/20 text-emerald-300 text-sm hover:bg-emerald-500/10 transition-colors", collapsed && "mx-2 px-0 justify-center")}><FlaskConical className="h-[18px] w-[18px] shrink-0" />{!collapsed && <span>Ricerca per meccanismi</span>}</a>
      {GROUPS.map((g) => (
        <div key={g.label} className={cn(collapsed ? "px-2" : "px-4")}>
          {!collapsed && (
            <p className="mb-2 px-3 text-[10px] font-semibold uppercase tracking-[0.22em] text-muted-foreground/70">
              {g.label}
            </p>
          )}
          <div className="space-y-1">
            {g.items.map(({ id, label, sub, Icon }) => {
              const active = section === id;
              const count = Number(counts?.[id] || 0);
              return (
                <button
                  key={id}
                  type="button"
                  data-testid={`section-${id}`}
                  onClick={() => onSelect(id)}
                  title={collapsed ? label : undefined}
                  className={cn(
                    "group flex w-full items-center gap-3 rounded-md px-3 py-2.5 text-left transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(var(--ring))]",
                    collapsed && "justify-center px-0",
                    active
                      ? "bg-accent text-foreground"
                      : "text-muted-foreground hover:text-foreground hover:bg-muted/50"
                  )}
                >
                  <span className="relative shrink-0">
                    <Icon className="h-[18px] w-[18px]" strokeWidth={active ? 2.2 : 1.8} />
                    {count > 0 && (
                      <span
                        data-testid={`section-badge-${id}`}
                        className="absolute -top-1.5 -right-2 flex h-3.5 min-w-3.5 items-center justify-center rounded-full bg-emerald-500 px-1 text-[8px] font-bold leading-none text-black"
                      >
                        {count > 99 ? "99+" : count}
                      </span>
                    )}
                  </span>
                  {!collapsed && (
                    <span className="leading-tight min-w-0">
                      <span className="block text-sm font-medium">{label}</span>
                      <span className="block text-[11px] text-muted-foreground/80 truncate">{sub}</span>
                    </span>
                  )}
                  {!collapsed && active && (
                    <span className="ml-auto h-1.5 w-1.5 rounded-full bg-emerald-500" />
                  )}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </nav>
    <button
      type="button"
      data-testid="sidebar-collapse-btn"
      onClick={onToggle}
      className="flex items-center gap-2 border-t border-border px-4 py-3 text-xs text-muted-foreground hover:text-foreground transition-colors"
    >
      {collapsed ? <PanelLeftOpen className="h-4 w-4 mx-auto" /> : (<><PanelLeftClose className="h-4 w-4" /> Comprimi</>)}
    </button>
  </aside>
);

export default AppSidebar;
